module.exports = __webpack_public_path__ + "static/media/drops.e016beab.svg";